import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between pb-5" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args))),
      class: _normalizeClass(_ctx.$attrs.inputClass)
    }, [
      _renderSlot(_ctx.$slots, "cell", {
        value: _ctx.modelValue,
        methods: {open: _ctx.open}
      }, () => [
        _createTextVNode(_toDisplayString(_ctx.displayValue), 1)
      ])
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "#selectModal" }, [
      _createVNode(_component_Modal, {
        ref: "modal",
        tabindex: "-1",
        visible: _ctx.visible,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
        backdrop: true
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$attrs.titolo), 1)
          ])
        ]),
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "main", { setInternalValue: _ctx.setInternalValue }, () => [
            _createVNode(_component_VueMultiselect, _mergeProps({
              options: _ctx.$attrs.autocomplete.options,
              modelValue: _ctx.$attrs.autocomplete.selection,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$attrs.autocomplete.selection) = $event)),
                _cache[2] || (_cache[2] = ($event: any) => (_ctx.internalModelValue = $event))
              ],
              loading: _ctx.$attrs.autocomplete.isLoading,
              onSearchChange: _ctx.$attrs.autocomplete.search,
              class: "mb-3",
              "close-on-select": true,
              "clear-on-select": false,
              deselectLabel: "Deseleziona",
              selectedLabel: "Selezionato",
              selectLabel: "Seleziona"
            }, _ctx.$attrs), null, 16, ["options", "modelValue", "loading", "onSearchChange"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_NextButton, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible=false)),
              variant: "outline-secondary",
              class: "w-44 py-1 px-2 mr-2"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Chiudi ")
              ])),
              _: 1
            }),
            _createVNode(_component_NextButton, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.visible=false; _ctx.$emit('confirm', _ctx.internalModelValue)}),
              variant: "outline-primary",
              class: "w-44 py-1 px-2"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Salva ")
              ])),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["visible"])
    ]))
  ], 64))
}